// extracted by mini-css-extract-plugin
export default {"container":"CardReaderHandler_container__pufJV","text":"CardReaderHandler_text__1EaxH"};